'use strict';

module.exports = require('./Table');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/~/rc-table/lib/index.js
// module id = 283
// module chunks = 0